import { Helmet } from "react-helmet-async";

/**
 * Injects JSON-LD structured data into the page head via react-helmet-async.
 *
 * @param {object} data - A schema.org JSON-LD object
 */
const StructuredData = ({ data }) => (
    <Helmet>
        <script type="application/ld+json">{JSON.stringify(data)}</script>
    </Helmet>
);

export default StructuredData;
